import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("menu-item-styles__navitem-29b8dc", {
  height: "100%",
  display: "flex",
  alignItems: "center"
});
const _staticStyles2 = _cssRef("menu-item-styles__trigger-3b915b", {
  display: "flex",
  select: "none",
  alignItems: "center",
  justifyContent: "space-between",
  height: "100%",
  cursor: "default",
  "& *": {
    cursor: "inherit"
  },
  "& svg": {
    cursor: "inherit"
  }
});
const _staticStyles3 = _cssRef("menu-item-styles__triggerhost-265781", {
  display: "flex",
  alignItems: "center",
  height: "100%",
  "& a[href]": {
    cursor: "pointer"
  },
  "& a[href] *": {
    cursor: "inherit"
  }
});
const _staticStyles4 = _cssRef("menu-item-styles__triggerdisclosure-2cedl8", {
  display: "flex",
  select: "none",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  padding: 0,
  cursor: "default",
  "& svg": {
    cursor: "inherit",
    transition: "transform 0.3s"
  },
  "&[data-state=\"open\"] svg": {
    transform: "rotate(180deg)"
  }
});
const _staticStyles5 = _cssRef("menu-item-styles__triggertouchmode-0c8zk7", {
  cursor: "default",
  "&:active": {
    transform: "scale(0.98)"
  }
});
const _staticStyles6 = _cssRef("menu-item-styles__caret-1icttl", {
  height: "5px",
  marginBottom: "4px",
  marginLeft: "5px"
});
const _staticStyles7 = _cssRef("menu-item-styles__content-2ct4o5", {
  position: "absolute",
  top: "0",
  left: "0",
  width: "auto",
  borderRadius: "0 0 4px 4px"
});
const _staticStyles8 = _cssRef("menu-item-styles__herobackground-2u72nj", {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: 0,
  backgroundSize: "cover",
  backgroundPosition: "center",
  "&::after": {
    content: "\"\"",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "var(--system-white)"
  }
});
const _staticStyles9 = _cssRef("menu-item-styles__outercontainer-3gq9rt", {
  margin: "0",
  display: "grid",
  gridTemplateColumns: "300px 1fr 400px",
  listStyleType: "none",
  width: "1200px",
  minHeight: "422px",
  backgroundColor: "var(--system-white)",
  position: "relative",
  overflow: "visible",
  borderRadius: "0 0 4px 4px",
  "@media (max-width: 1200px)": {
    gridTemplateColumns: "200px 1fr",
    maxWidth: "95vw"
  },
  "@media (max-width: 767px)": {
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto",
    maxWidth: "100vw",
    height: "auto"
  }
});
const _staticStyles0 = _cssRef("menu-item-styles__categoriessection-0wddp9", {
  backgroundColor: "var(--system-white)",
  borderRadius: "4px 0 0 0",
  padding: "16px",
  width: "300px",
  height: "auto",
  zIndex: 5,
  position: "relative",
  gridColumn: "1",
  overflow: "visible",
  "@media (max-width: 1200px)": {
    width: "200px",
    padding: "8px"
  },
  "@media (max-width: 767px)": {
    width: "100%",
    padding: "8px",
    gridColumn: "1",
    gridRow: "1"
  }
});
const _staticStyles1 = _cssRef("menu-item-styles__categorieslist-1fxlyr", {
  display: "flex",
  flexDirection: "column",
  gap: "0"
});
const _staticStyles10 = _cssRef("menu-item-styles__categoryitem-0mi5i9", {
  minHeight: "50px",
  display: "flex",
  alignItems: "center",
  gap: "16px",
  padding: "8px 0 8px 6px",
  cursor: "pointer",
  transition: "all 0.2s ease",
  borderBottom: "1px solid var(--system-grey-200)",
  "&:hover": {
    backgroundColor: "var(--primary-orange-50)"
  }
});
const _staticStyles11 = _cssRef("menu-item-styles__categoryitemtouchdisabled-0x8iwn", {
  cursor: "default"
});
const _staticStyles12 = _cssRef("menu-item-styles__activecategoryitem-2w2sjj", {
  backgroundColor: "transparent",
  "& .category-text": {
    color: "var(--primary-orange-500)"
  }
});
const _staticStyles13 = _cssRef("menu-item-styles__categoryicon-355mjl", {
  width: "36px",
  height: "36px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});
const _staticStyles14 = _cssRef("menu-item-styles__categorytext-2p04zy", {
  fontFamily: "Graphie, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
  fontSize: "18px",
  fontWeight: 350,
  color: "var(--system-grey-500)",
  lineHeight: "1.2",
  flex: 1,
  transition: "color 0.2s ease",
  whiteSpace: "nowrap !important",
  overflow: "visible !important",
  textOverflow: "clip !important",
  "@media (max-width: 1200px)": {
    fontSize: "16px",
    whiteSpace: "normal !important",
    lineHeight: "1.2"
  }
});
const _staticStyles15 = _cssRef("menu-item-styles__activecategorytext-18vssh", {
  color: "var(--primary-orange-500)"
});
const _staticStyles16 = _cssRef("menu-item-styles__categoryarrow-238ga5", {
  width: "7px",
  height: "12px",
  transition: "color 0.2s ease",
  paddingRight: "16px",
  display: "block",
  color: "var(--primary-orange-500)"
});
const _staticStyles17 = _cssRef("menu-item-styles__contentsection-0jkzqe", {
  padding: "16px",
  backgroundColor: "var(--system-white)",
  zIndex: 5,
  position: "relative",
  height: "100%",
  overflow: "hidden",
  gridColumn: "2",
  "@media (max-width: 1200px)": {
    padding: "12px 16px 12px 12px"
  },
  "@media (max-width: 767px)": {
    gridColumn: "1",
    gridRow: "2",
    padding: "12px"
  }
});
const _staticStyles18 = _cssRef("menu-item-styles__contenttitle-0vw06x", {
  fontFamily: "Graphie, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
  fontSize: "30px",
  fontWeight: 350,
  color: "#353535",
  lineHeight: "1.067",
  margin: "0 0 24px 0",
  whiteSpace: "normal",
  overflow: "visible",
  textOverflow: "clip",
  "@media (max-width: 1200px)": {
    fontSize: "20px",
    margin: "0 0 12px 0",
    lineHeight: "1.1"
  }
});
const _staticStyles19 = _cssRef("menu-item-styles__contentdescription-1yx9om", {
  fontFamily: "Graphie, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
  fontSize: "18px",
  fontWeight: 350,
  color: "#000000",
  lineHeight: "1.2",
  margin: "0 0 24px 0",
  "@media (max-width: 1200px)": {
    fontSize: "14px",
    margin: "0 0 16px 0"
  }
});
const _staticStyles20 = _cssRef("menu-item-styles__serviceslist-2lbdb0", {
  display: "flex",
  flexDirection: "column",
  gap: "0",
  marginTop: "12px",
  marginBottom: "16px",
  backgroundColor: "var(--primary-orange-25)",
  borderRadius: "4px",
  border: "1px solid var(--primary-orange-500)",
  padding: "12px 16px",
  "@media (max-width: 1200px)": {
    padding: "8px",
    marginTop: "8px",
    marginBottom: "12px"
  }
});
const _staticStyles21 = _cssRef("menu-item-styles__serviceitem-3c2stq", {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  cursor: "pointer",
  padding: "0",
  textDecoration: "none",
  transition: "all 0.2s ease",
  "&:hover": {
    color: "var(--primary-orange-500)",
    "& span": {
      color: "var(--primary-orange-500)"
    }
  }
});
const _staticStyles22 = _cssRef("menu-item-styles__serviceicon-2k2v7v", {
  width: "19px",
  height: "19px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});
const _staticStyles23 = _cssRef("menu-item-styles__servicetext-2xkiek", {
  fontFamily: "Graphie, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
  fontSize: "18px",
  fontWeight: 350,
  color: "#353535",
  lineHeight: "1.56",
  "@media (max-width: 1200px)": {
    fontSize: "14px",
    lineHeight: "1.3"
  }
});
const _staticStyles24 = _cssRef("menu-item-styles__imagesection-0ky4cj", {
  padding: "24px 16px",
  backgroundColor: "var(--system-white)",
  zIndex: 5,
  position: "relative",
  height: "100%",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gridColumn: "3",
  width: "400px",
  "@media (max-width: 1200px)": {
    display: "none"
  }
});
const _staticStyles25 = _cssRef("menu-item-styles__megamenucontentimageframe-0up14k", {
  backgroundColor: "var(--system-grey-300)",
  borderRadius: "5px",
  width: "353px",
  height: "362px",
  maxHeight: "362px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0
});
const _staticStyles26 = _cssRef("menu-item-styles__contentimage-01lwng", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  maxWidth: "353px",
  maxHeight: "362px",
  flexShrink: 0,
  borderRadius: "5px",
  overflow: "hidden",
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center center"
  },
  "@media (max-width: 1200px)": {
    width: "206px",
    height: "208px"
  }
});
import { colors } from '../../primitives/colors';
import { breakpoints, fontGraphieMenuStack } from '../../primitives/tokens';

/** Megamenu hero image — CSS width / `<img sizes>`; aligned with GraphQL ~2× cap (720w). */
export const MEGAMENU_IMAGE_WIDTH = '353px';
/** Max frame height (not a forced aspect ratio — avoids CLS/tooling mismatches). */
export const MEGAMENU_IMAGE_MAX_HEIGHT = '362px';

/** Left-column category icons — `categoryIcon` flex slot width/height and `<img sizes>`. */
export const MEGAMENU_CATEGORY_ICON_SIZES = '36px';
/** Service-row icons — `serviceIcon` flex slot width/height and `<img sizes>`. */
export const MEGAMENU_SERVICE_ICON_SIZES = '19px';
const styles = {
  navItem: _staticStyles,
  trigger: _staticStyles2,
  triggerHost: _staticStyles3,
  triggerDisclosure: _staticStyles4,
  triggerTouchMode: _staticStyles5,
  caret: _staticStyles6,
  content: _staticStyles7,
  heroBackground: _staticStyles8,
  outerContainer: _staticStyles9,
  categoriesSection: _staticStyles0,
  categoriesList: _staticStyles1,
  categoryItem: _staticStyles10,
  categoryItemTouchDisabled: _staticStyles11,
  activeCategoryItem: _staticStyles12,
  categoryIcon: _staticStyles13,
  categoryText: _staticStyles14,
  activeCategoryText: _staticStyles15,
  categoryArrow: _staticStyles16,
  contentSection: _staticStyles17,
  contentTitle: _staticStyles18,
  contentDescription: _staticStyles19,
  servicesList: _staticStyles20,
  serviceItem: _staticStyles21,
  serviceIcon: _staticStyles22,
  serviceText: _staticStyles23,
  imageSection: _staticStyles24,
  megamenuContentImageFrame: _staticStyles25,
  contentImage: _staticStyles26
};
export default styles;